

function readMore() {
	return;

	var element = document.getElementById('courseDescription');
	var button = document.getElementById('readMore');
	var fade = document.getElementById('tallFade');

	var resizeHandle = function() {
		if (!document.documentElement.contains(element)) {
			$(window).off('resize.courseDescription', resizeHandle);
			return;
		}
		
		element.style.setProperty('--content-height', element.querySelector(':scope > div').offsetHeight + 'px');
	}
	
	$(window).on('resize.courseDescription', resizeHandle);
	
	if (element.scrollHeight > element.offsetHeight) {
		button.classList.add('active');
		element.classList.add('tall');
	}
	
	resizeHandle();

	$(button).off('click.readMore').on('click.readMore', function() {
		$('#courseDescription').toggleClass('expanded');
		$('#readMore').toggleClass('expanded');
		require('tabbed-content').fix();
	});
}
